import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Identifier: { input: string; output: string };
};

export type Attribute = {
  __typename?: "Attribute";
  id: Maybe<Scalars["Int"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type BuyerIntentProduct = {
  __typename?: "BuyerIntentProduct";
  id: Maybe<Scalars["Int"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type BuyerIntentProductData = {
  __typename?: "BuyerIntentProductData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<BuyerIntentProduct>>>;
};

export type BuyerIntentVendor = {
  __typename?: "BuyerIntentVendor";
  description: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Int"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  url: Maybe<Scalars["String"]["output"]>;
};

export type BuyerIntentVendorData = {
  __typename?: "BuyerIntentVendorData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<BuyerIntentVendor>>>;
};

export type Category = {
  __typename?: "Category";
  code: Maybe<Scalars["String"]["output"]>;
  hasInstalls: Maybe<Scalars["Boolean"]["output"]>;
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  nameTree: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  parentId: Maybe<Scalars["Identifier"]["output"]>;
  spendCategoryId: Maybe<Scalars["Identifier"]["output"]>;
};

export type CategoryData = {
  __typename?: "CategoryData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<Category>>>;
};

export type ChildrenProductAttributes = {
  __typename?: "ChildrenProductAttributes";
  description: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Int"]["output"]>;
  level: Maybe<Scalars["Int"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type CloudMaturityRange = {
  __typename?: "CloudMaturityRange";
  displayName: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  rangeMax: Maybe<Scalars["Int"]["output"]>;
  rangeMin: Maybe<Scalars["Int"]["output"]>;
};

export type CloudMaturityRangeData = {
  __typename?: "CloudMaturityRangeData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<CloudMaturityRange>>>;
};

export type Company = {
  __typename?: "Company";
  hgId: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  parent: Maybe<Company>;
};

export type CompanyData = {
  __typename?: "CompanyData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<Company>>>;
};

export type ContactJobFunction = {
  __typename?: "ContactJobFunction";
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  subFunctions: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type ContactJobFunctionData = {
  __typename?: "ContactJobFunctionData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<ContactJobFunction>>>;
};

export type ContactJobSeniority = {
  __typename?: "ContactJobSeniority";
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type ContactJobSeniorityData = {
  __typename?: "ContactJobSeniorityData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<ContactJobSeniority>>>;
};

export type Country = {
  __typename?: "Country";
  aliases: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  alpha2: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  region: Maybe<Region>;
};

export type CountryData = {
  __typename?: "CountryData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<Country>>>;
};

export type Duns = {
  __typename?: "Duns";
  city: Maybe<Scalars["String"]["output"]>;
  companyName: Maybe<Scalars["String"]["output"]>;
  country: Maybe<Scalars["String"]["output"]>;
  dunsFormatted: Maybe<Scalars["String"]["output"]>;
  dunsId: Maybe<Scalars["Int"]["output"]>;
  state: Maybe<Scalars["String"]["output"]>;
  streetAddress: Maybe<Scalars["String"]["output"]>;
  tradeStyleName: Maybe<Scalars["String"]["output"]>;
  zipCode: Maybe<Scalars["String"]["output"]>;
};

export type FaiDepartment = {
  __typename?: "FaiDepartment";
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  /** Get FAI Roles */
  roles: Maybe<Array<Maybe<FaiRole>>>;
};

export type FaiDepartmentRolesArgs = {
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type FaiDepartmentData = {
  __typename?: "FaiDepartmentData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<FaiDepartment>>>;
};

export type FaiRole = {
  __typename?: "FaiRole";
  departmentId: Maybe<Scalars["Identifier"]["output"]>;
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type FaiRoleData = {
  __typename?: "FaiRoleData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<FaiRole>>>;
};

export type HasMatching = {
  __typename?: "HasMatching";
  taxonomy: Maybe<Scalars["Boolean"]["output"]>;
};

export type Industry = {
  __typename?: "Industry";
  id: Maybe<Scalars["Int"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type IndustryData = {
  __typename?: "IndustryData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<Industry>>>;
};

export type IntentBuyersJourney = {
  __typename?: "IntentBuyersJourney";
  description: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type IntentBuyersJourneyData = {
  __typename?: "IntentBuyersJourneyData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<IntentBuyersJourney>>>;
};

export type IntentContextType = {
  __typename?: "IntentContextType";
  description: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type IntentContextTypeData = {
  __typename?: "IntentContextTypeData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<IntentContextType>>>;
};

export type IntentTopic = {
  __typename?: "IntentTopic";
  category: Maybe<Scalars["String"]["output"]>;
  collectionTree: Maybe<Array<Maybe<Scalars["Identifier"]["output"]>>>;
  displayName: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Identifier"]["output"]>;
  topicName: Maybe<Scalars["String"]["output"]>;
};

export type IntentTopicCollectionTree = {
  __typename?: "IntentTopicCollectionTree";
  displayName: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Identifier"]["output"]>;
  parentId: Maybe<Scalars["Identifier"]["output"]>;
};

export type IntentTopicCollectionTreeData = {
  __typename?: "IntentTopicCollectionTreeData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<IntentTopicCollectionTree>>>;
};

export type IntentTopicData = {
  __typename?: "IntentTopicData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<IntentTopic>>>;
};

export type Naics2012 = {
  __typename?: "Naics2012";
  code: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  parentId: Maybe<Scalars["Identifier"]["output"]>;
  topLevelParent: Maybe<TopParentNaics2012>;
};

export type Naics2012Data = {
  __typename?: "Naics2012Data";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<Naics2012>>>;
};

export type Product = {
  __typename?: "Product";
  /** Get Product Attributes */
  attributes: Maybe<Array<Maybe<Attribute>>>;
  category: Maybe<Category>;
  description: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated This field is no longer supported and always returns false */
  isAiRoboticsProduct: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated This field is no longer supported and always returns false */
  isBlockchainProduct: Maybe<Scalars["Boolean"]["output"]>;
  isCloudProduct: Maybe<Scalars["Boolean"]["output"]>;
  isMobileProduct: Maybe<Scalars["Boolean"]["output"]>;
  isOnPremiseProduct: Maybe<Scalars["Boolean"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  vendor: Maybe<Vendor>;
};

export type ProductAttributes = {
  __typename?: "ProductAttributes";
  childrenAttributes: Maybe<Array<Maybe<ChildrenProductAttributes>>>;
  description: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Int"]["output"]>;
  level: Maybe<Scalars["Int"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type ProductAttributesData = {
  __typename?: "ProductAttributesData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<ProductAttributes>>>;
};

export type ProductData = {
  __typename?: "ProductData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<Product>>>;
};

export type Region = {
  __typename?: "Region";
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type RegionData = {
  __typename?: "RegionData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<Region>>>;
};

export type RootQueryType = {
  __typename?: "RootQueryType";
  /** Get all buyer intent products or search by product ids or product name */
  buyerIntentProduct: Maybe<BuyerIntentProductData>;
  /** Get all buyer intent vendors or search by ids or name */
  buyerIntentVendor: Maybe<BuyerIntentVendorData>;
  /** Get all categories or search by id */
  category: Maybe<CategoryData>;
  /** Get all cloud maturity ranges */
  cloudMaturityRange: Maybe<CloudMaturityRangeData>;
  /** Get company data by hg_ids */
  company: Maybe<CompanyData>;
  /** Get all contact job functions */
  contactJobFunctions: Maybe<ContactJobFunctionData>;
  /** Get all contact job seniority levels */
  contactJobSeniority: Maybe<ContactJobSeniorityData>;
  /** Get all countries or search for them by alpha2 code(s) or by region name */
  country: Maybe<CountryData>;
  /** Get D&B data by duns ID */
  duns: Maybe<Duns>;
  /** Get all FAI Departments and its roles */
  faiDepartment: Maybe<FaiDepartmentData>;
  /** Get all FAI Roles and its departments */
  faiRole: Maybe<FaiRoleData>;
  /** Get all industries or search by code */
  industry: Maybe<IndustryData>;
  /** Get all intent buyers journey */
  intentBuyersJourney: Maybe<IntentBuyersJourneyData>;
  /** Get all intent context types */
  intentContextType: Maybe<IntentContextTypeData>;
  /** Get intent topics(all or provisioned for specific user) filtered by ids or display_name */
  intentTopic: Maybe<IntentTopicData>;
  /** Get intent topics collection tree */
  intentTopicCollectionTree: Maybe<IntentTopicCollectionTreeData>;
  /** Get all mentions or search by product ids or product name */
  mention: Maybe<ProductData>;
  /** Get all NAICS 2012 codes or search by id */
  naics2012: Maybe<Naics2012Data>;
  /** Get all products or search by product ids, product name, vendor ids, category ids or attribute ids */
  product: Maybe<ProductData>;
  /** Get all product attributes */
  productAttributes: Maybe<ProductAttributesData>;
  /** Get all regions or search for them by region name(s) */
  region: Maybe<RegionData>;
  /** Get all SIC US 1987 codes or search by id */
  sicUs1987: Maybe<SicUs1987Data>;
  /** Get all AI spend categories */
  spendAiCategory: Maybe<SpendAiCategoryData>;
  /** Get all spend categories */
  spendCategory: Maybe<SpendCategoryData>;
  /** Get all states or search by country_alpha2 */
  state: Maybe<StateData>;
  /** Get suggested intent topics based on selected topic ids */
  suggestedTopic: Maybe<SuggestedTopicData>;
  /** Get all vendors or search by ids, name, category ids or attribute ids */
  vendor: Maybe<VendorData>;
};

export type RootQueryTypeBuyerIntentProductArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RootQueryTypeBuyerIntentVendorArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RootQueryTypeCategoryArgs = {
  id?: InputMaybe<Scalars["Identifier"]["input"]>;
};

export type RootQueryTypeCompanyArgs = {
  hgIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
};

export type RootQueryTypeContactJobFunctionsArgs = {
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RootQueryTypeContactJobSeniorityArgs = {
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RootQueryTypeCountryArgs = {
  alpha2?: InputMaybe<Scalars["String"]["input"]>;
  alpha2List?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  regionName?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootQueryTypeDunsArgs = {
  dunsId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RootQueryTypeFaiDepartmentArgs = {
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RootQueryTypeIndustryArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RootQueryTypeIntentTopicArgs = {
  displayName?: InputMaybe<Scalars["String"]["input"]>;
  displayNames?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  ignoreProvisioning?: InputMaybe<Scalars["Boolean"]["input"]>;
  userEmail?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootQueryTypeMentionArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RootQueryTypeNaics2012Args = {
  filterTerm?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
};

export type RootQueryTypeProductArgs = {
  attributeIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type RootQueryTypeProductAttributesArgs = {
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RootQueryTypeRegionArgs = {
  regionName?: InputMaybe<Scalars["String"]["input"]>;
  regionNameList?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type RootQueryTypeSicUs1987Args = {
  id?: InputMaybe<Scalars["Identifier"]["input"]>;
};

export type RootQueryTypeSpendAiCategoryArgs = {
  id?: InputMaybe<Scalars["Identifier"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RootQueryTypeSpendCategoryArgs = {
  id?: InputMaybe<Scalars["Identifier"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RootQueryTypeStateArgs = {
  countryAlpha2?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
};

export type RootQueryTypeSuggestedTopicArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
};

export type RootQueryTypeVendorArgs = {
  attributeIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type SicUs1987 = {
  __typename?: "SicUs1987";
  code: Maybe<Scalars["String"]["output"]>;
  codeStandard: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  parentId: Maybe<Scalars["Identifier"]["output"]>;
};

export type SicUs1987Data = {
  __typename?: "SicUs1987Data";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<SicUs1987>>>;
};

export type Sort = {
  direction?: InputMaybe<SortDir>;
  field?: InputMaybe<Scalars["String"]["input"]>;
};

export enum SortDir {
  ASC = "ASC",
  DESC = "DESC",
}

export type SpendAiCategory = {
  __typename?: "SpendAiCategory";
  description: Maybe<Scalars["String"]["output"]>;
  exportName: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  nameTree: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  parentId: Maybe<Scalars["Identifier"]["output"]>;
};

export type SpendAiCategoryData = {
  __typename?: "SpendAiCategoryData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<SpendAiCategory>>>;
};

export type SpendCategory = {
  __typename?: "SpendCategory";
  description: Maybe<Scalars["String"]["output"]>;
  exportName: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  nameTree: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  parentId: Maybe<Scalars["Identifier"]["output"]>;
};

export type SpendCategoryData = {
  __typename?: "SpendCategoryData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<SpendCategory>>>;
};

export type State = {
  __typename?: "State";
  country: Maybe<Country>;
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type StateData = {
  __typename?: "StateData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<State>>>;
};

export type SuggestedTopic = {
  __typename?: "SuggestedTopic";
  hasMatching: Maybe<HasMatching>;
  matchingTopic: Maybe<IntentTopic>;
  score: Maybe<Scalars["Float"]["output"]>;
};

export type SuggestedTopicData = {
  __typename?: "SuggestedTopicData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<SuggestedTopic>>>;
};

export type TopParentNaics2012 = {
  __typename?: "TopParentNaics2012";
  code: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type Vendor = {
  __typename?: "Vendor";
  description: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Int"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  url: Maybe<Scalars["String"]["output"]>;
};

export type VendorData = {
  __typename?: "VendorData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<Vendor>>>;
};

export type GetBuyerIntentProductsQueryVariables = Exact<{
  ids?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  name?: InputMaybe<Scalars["String"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<Sort>> | InputMaybe<Sort>>;
}>;

export type GetBuyerIntentProductsQuery = {
  __typename?: "RootQueryType";
  buyerIntentProduct: {
    __typename?: "BuyerIntentProductData";
    count: number | null;
    data: Array<{
      __typename?: "BuyerIntentProduct";
      id: number | null;
      name: string | null;
    } | null> | null;
  } | null;
};

export type GetBuyerIntentVendorsQueryVariables = Exact<{
  ids?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  name?: InputMaybe<Scalars["String"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<Sort>> | InputMaybe<Sort>>;
}>;

export type GetBuyerIntentVendorsQuery = {
  __typename?: "RootQueryType";
  buyerIntentVendor: {
    __typename?: "BuyerIntentVendorData";
    count: number | null;
    data: Array<{
      __typename?: "BuyerIntentVendor";
      id: number | null;
      name: string | null;
      url: string | null;
      description: string | null;
    } | null> | null;
  } | null;
};

export type SearchBuyerIntentProductsQueryVariables = Exact<{
  name: Scalars["String"]["input"];
}>;

export type SearchBuyerIntentProductsQuery = {
  __typename?: "RootQueryType";
  buyerIntentProduct: {
    __typename?: "BuyerIntentProductData";
    count: number | null;
    data: Array<{
      __typename?: "BuyerIntentProduct";
      id: number | null;
      name: string | null;
    } | null> | null;
  } | null;
};

export type SearchBuyerIntentVendorsQueryVariables = Exact<{
  name: Scalars["String"]["input"];
}>;

export type SearchBuyerIntentVendorsQuery = {
  __typename?: "RootQueryType";
  buyerIntentVendor: {
    __typename?: "BuyerIntentVendorData";
    count: number | null;
    data: Array<{
      __typename?: "BuyerIntentVendor";
      id: number | null;
      name: string | null;
      url: string | null;
      description: string | null;
    } | null> | null;
  } | null;
};

export type ContactJobFunctionsQueryVariables = Exact<{ [key: string]: never }>;

export type ContactJobFunctionsQuery = {
  __typename?: "RootQueryType";
  contactJobFunctions: {
    __typename?: "ContactJobFunctionData";
    data: Array<{
      __typename?: "ContactJobFunction";
      id: string | null;
      name: string | null;
      subFunctions: Array<string | null> | null;
    } | null> | null;
  } | null;
};

export type GetIntentTopicCollectionTreeQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetIntentTopicCollectionTreeQuery = {
  __typename?: "RootQueryType";
  intentTopicCollectionTree: {
    __typename?: "IntentTopicCollectionTreeData";
    count: number | null;
    data: Array<{
      __typename?: "IntentTopicCollectionTree";
      id: string | null;
      displayName: string | null;
      parentId: string | null;
    } | null> | null;
  } | null;
};

export type GetIntentBuyersJourneyQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetIntentBuyersJourneyQuery = {
  __typename?: "RootQueryType";
  intentBuyersJourney: {
    __typename?: "IntentBuyersJourneyData";
    count: number | null;
    data: Array<{
      __typename?: "IntentBuyersJourney";
      id: string | null;
      name: string | null;
      description: string | null;
    } | null> | null;
  } | null;
};

export type GetIntentContextTypesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetIntentContextTypesQuery = {
  __typename?: "RootQueryType";
  intentContextType: {
    __typename?: "IntentContextTypeData";
    count: number | null;
    data: Array<{
      __typename?: "IntentContextType";
      id: string | null;
      name: string | null;
      description: string | null;
    } | null> | null;
  } | null;
};

export type GetSuggestedTopicsQueryVariables = Exact<{
  ids: Array<Scalars["Identifier"]["input"]> | Scalars["Identifier"]["input"];
}>;

export type GetSuggestedTopicsQuery = {
  __typename?: "RootQueryType";
  suggestedTopic: {
    __typename?: "SuggestedTopicData";
    count: number | null;
    data: Array<{
      __typename?: "SuggestedTopic";
      score: number | null;
      matchingTopic: {
        __typename?: "IntentTopic";
        id: string | null;
        displayName: string | null;
      } | null;
      hasMatching: {
        __typename?: "HasMatching";
        taxonomy: boolean | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetIntentTopicsQueryVariables = Exact<{
  ids?: InputMaybe<
    | Array<InputMaybe<Scalars["Identifier"]["input"]>>
    | InputMaybe<Scalars["Identifier"]["input"]>
  >;
  displayNames?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
  displayName?: InputMaybe<Scalars["String"]["input"]>;
  ignoreProvisioning?: InputMaybe<Scalars["Boolean"]["input"]>;
  userEmail?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetIntentTopicsQuery = {
  __typename?: "RootQueryType";
  intentTopic: {
    __typename?: "IntentTopicData";
    count: number | null;
    data: Array<{
      __typename?: "IntentTopic";
      id: string | null;
      topicName: string | null;
      displayName: string | null;
      category: string | null;
      collectionTree: Array<string | null> | null;
    } | null> | null;
  } | null;
};

export type GetIntentTopicsByIdsQueryVariables = Exact<{
  ids: Array<Scalars["Identifier"]["input"]> | Scalars["Identifier"]["input"];
}>;

export type GetIntentTopicsByIdsQuery = {
  __typename?: "RootQueryType";
  intentTopic: {
    __typename?: "IntentTopicData";
    count: number | null;
    data: Array<{
      __typename?: "IntentTopic";
      id: string | null;
      topicName: string | null;
      displayName: string | null;
      category: string | null;
      collectionTree: Array<string | null> | null;
    } | null> | null;
  } | null;
};

export type SearchIntentTopicsQueryVariables = Exact<{
  displayName: Scalars["String"]["input"];
}>;

export type SearchIntentTopicsQuery = {
  __typename?: "RootQueryType";
  intentTopic: {
    __typename?: "IntentTopicData";
    count: number | null;
    data: Array<{
      __typename?: "IntentTopic";
      id: string | null;
      topicName: string | null;
      displayName: string | null;
      category: string | null;
      collectionTree: Array<string | null> | null;
    } | null> | null;
  } | null;
};

export const GetBuyerIntentProductsDocument = gql`
  query GetBuyerIntentProducts($ids: [Int], $name: String, $sort: [Sort]) {
    buyerIntentProduct(ids: $ids, name: $name, sort: $sort) {
      data {
        id
        name
      }
      count
    }
  }
`;

/**
 * __useGetBuyerIntentProductsQuery__
 *
 * To run a query within a React component, call `useGetBuyerIntentProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyerIntentProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyerIntentProductsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      name: // value for 'name'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetBuyerIntentProductsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetBuyerIntentProductsQuery,
    GetBuyerIntentProductsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetBuyerIntentProductsQuery,
    GetBuyerIntentProductsQueryVariables
  >(GetBuyerIntentProductsDocument, options);
}
export function useGetBuyerIntentProductsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetBuyerIntentProductsQuery,
    GetBuyerIntentProductsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetBuyerIntentProductsQuery,
    GetBuyerIntentProductsQueryVariables
  >(GetBuyerIntentProductsDocument, options);
}
export function useGetBuyerIntentProductsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        GetBuyerIntentProductsQuery,
        GetBuyerIntentProductsQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    GetBuyerIntentProductsQuery,
    GetBuyerIntentProductsQueryVariables
  >(GetBuyerIntentProductsDocument, options);
}
export type GetBuyerIntentProductsQueryHookResult = ReturnType<
  typeof useGetBuyerIntentProductsQuery
>;
export type GetBuyerIntentProductsLazyQueryHookResult = ReturnType<
  typeof useGetBuyerIntentProductsLazyQuery
>;
export type GetBuyerIntentProductsSuspenseQueryHookResult = ReturnType<
  typeof useGetBuyerIntentProductsSuspenseQuery
>;
export type GetBuyerIntentProductsQueryResult = Apollo.QueryResult<
  GetBuyerIntentProductsQuery,
  GetBuyerIntentProductsQueryVariables
>;
export const GetBuyerIntentVendorsDocument = gql`
  query GetBuyerIntentVendors($ids: [Int], $name: String, $sort: [Sort]) {
    buyerIntentVendor(ids: $ids, name: $name, sort: $sort) {
      data {
        id
        name
        url
        description
      }
      count
    }
  }
`;

/**
 * __useGetBuyerIntentVendorsQuery__
 *
 * To run a query within a React component, call `useGetBuyerIntentVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyerIntentVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyerIntentVendorsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      name: // value for 'name'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetBuyerIntentVendorsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetBuyerIntentVendorsQuery,
    GetBuyerIntentVendorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetBuyerIntentVendorsQuery,
    GetBuyerIntentVendorsQueryVariables
  >(GetBuyerIntentVendorsDocument, options);
}
export function useGetBuyerIntentVendorsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetBuyerIntentVendorsQuery,
    GetBuyerIntentVendorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetBuyerIntentVendorsQuery,
    GetBuyerIntentVendorsQueryVariables
  >(GetBuyerIntentVendorsDocument, options);
}
export function useGetBuyerIntentVendorsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        GetBuyerIntentVendorsQuery,
        GetBuyerIntentVendorsQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    GetBuyerIntentVendorsQuery,
    GetBuyerIntentVendorsQueryVariables
  >(GetBuyerIntentVendorsDocument, options);
}
export type GetBuyerIntentVendorsQueryHookResult = ReturnType<
  typeof useGetBuyerIntentVendorsQuery
>;
export type GetBuyerIntentVendorsLazyQueryHookResult = ReturnType<
  typeof useGetBuyerIntentVendorsLazyQuery
>;
export type GetBuyerIntentVendorsSuspenseQueryHookResult = ReturnType<
  typeof useGetBuyerIntentVendorsSuspenseQuery
>;
export type GetBuyerIntentVendorsQueryResult = Apollo.QueryResult<
  GetBuyerIntentVendorsQuery,
  GetBuyerIntentVendorsQueryVariables
>;
export const SearchBuyerIntentProductsDocument = gql`
  query SearchBuyerIntentProducts($name: String!) {
    buyerIntentProduct(name: $name) {
      data {
        id
        name
      }
      count
    }
  }
`;

/**
 * __useSearchBuyerIntentProductsQuery__
 *
 * To run a query within a React component, call `useSearchBuyerIntentProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBuyerIntentProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBuyerIntentProductsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSearchBuyerIntentProductsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SearchBuyerIntentProductsQuery,
    SearchBuyerIntentProductsQueryVariables
  > &
    (
      | { variables: SearchBuyerIntentProductsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    SearchBuyerIntentProductsQuery,
    SearchBuyerIntentProductsQueryVariables
  >(SearchBuyerIntentProductsDocument, options);
}
export function useSearchBuyerIntentProductsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SearchBuyerIntentProductsQuery,
    SearchBuyerIntentProductsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    SearchBuyerIntentProductsQuery,
    SearchBuyerIntentProductsQueryVariables
  >(SearchBuyerIntentProductsDocument, options);
}
export function useSearchBuyerIntentProductsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        SearchBuyerIntentProductsQuery,
        SearchBuyerIntentProductsQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    SearchBuyerIntentProductsQuery,
    SearchBuyerIntentProductsQueryVariables
  >(SearchBuyerIntentProductsDocument, options);
}
export type SearchBuyerIntentProductsQueryHookResult = ReturnType<
  typeof useSearchBuyerIntentProductsQuery
>;
export type SearchBuyerIntentProductsLazyQueryHookResult = ReturnType<
  typeof useSearchBuyerIntentProductsLazyQuery
>;
export type SearchBuyerIntentProductsSuspenseQueryHookResult = ReturnType<
  typeof useSearchBuyerIntentProductsSuspenseQuery
>;
export type SearchBuyerIntentProductsQueryResult = Apollo.QueryResult<
  SearchBuyerIntentProductsQuery,
  SearchBuyerIntentProductsQueryVariables
>;
export const SearchBuyerIntentVendorsDocument = gql`
  query SearchBuyerIntentVendors($name: String!) {
    buyerIntentVendor(name: $name) {
      data {
        id
        name
        url
        description
      }
      count
    }
  }
`;

/**
 * __useSearchBuyerIntentVendorsQuery__
 *
 * To run a query within a React component, call `useSearchBuyerIntentVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBuyerIntentVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBuyerIntentVendorsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSearchBuyerIntentVendorsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SearchBuyerIntentVendorsQuery,
    SearchBuyerIntentVendorsQueryVariables
  > &
    (
      | { variables: SearchBuyerIntentVendorsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    SearchBuyerIntentVendorsQuery,
    SearchBuyerIntentVendorsQueryVariables
  >(SearchBuyerIntentVendorsDocument, options);
}
export function useSearchBuyerIntentVendorsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SearchBuyerIntentVendorsQuery,
    SearchBuyerIntentVendorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    SearchBuyerIntentVendorsQuery,
    SearchBuyerIntentVendorsQueryVariables
  >(SearchBuyerIntentVendorsDocument, options);
}
export function useSearchBuyerIntentVendorsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        SearchBuyerIntentVendorsQuery,
        SearchBuyerIntentVendorsQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    SearchBuyerIntentVendorsQuery,
    SearchBuyerIntentVendorsQueryVariables
  >(SearchBuyerIntentVendorsDocument, options);
}
export type SearchBuyerIntentVendorsQueryHookResult = ReturnType<
  typeof useSearchBuyerIntentVendorsQuery
>;
export type SearchBuyerIntentVendorsLazyQueryHookResult = ReturnType<
  typeof useSearchBuyerIntentVendorsLazyQuery
>;
export type SearchBuyerIntentVendorsSuspenseQueryHookResult = ReturnType<
  typeof useSearchBuyerIntentVendorsSuspenseQuery
>;
export type SearchBuyerIntentVendorsQueryResult = Apollo.QueryResult<
  SearchBuyerIntentVendorsQuery,
  SearchBuyerIntentVendorsQueryVariables
>;
export const ContactJobFunctionsDocument = gql`
  query ContactJobFunctions {
    contactJobFunctions {
      data {
        id
        name
        subFunctions
      }
    }
  }
`;

/**
 * __useContactJobFunctionsQuery__
 *
 * To run a query within a React component, call `useContactJobFunctionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactJobFunctionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactJobFunctionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactJobFunctionsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ContactJobFunctionsQuery,
    ContactJobFunctionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    ContactJobFunctionsQuery,
    ContactJobFunctionsQueryVariables
  >(ContactJobFunctionsDocument, options);
}
export function useContactJobFunctionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ContactJobFunctionsQuery,
    ContactJobFunctionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    ContactJobFunctionsQuery,
    ContactJobFunctionsQueryVariables
  >(ContactJobFunctionsDocument, options);
}
export function useContactJobFunctionsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        ContactJobFunctionsQuery,
        ContactJobFunctionsQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    ContactJobFunctionsQuery,
    ContactJobFunctionsQueryVariables
  >(ContactJobFunctionsDocument, options);
}
export type ContactJobFunctionsQueryHookResult = ReturnType<
  typeof useContactJobFunctionsQuery
>;
export type ContactJobFunctionsLazyQueryHookResult = ReturnType<
  typeof useContactJobFunctionsLazyQuery
>;
export type ContactJobFunctionsSuspenseQueryHookResult = ReturnType<
  typeof useContactJobFunctionsSuspenseQuery
>;
export type ContactJobFunctionsQueryResult = Apollo.QueryResult<
  ContactJobFunctionsQuery,
  ContactJobFunctionsQueryVariables
>;
export const GetIntentTopicCollectionTreeDocument = gql`
  query GetIntentTopicCollectionTree {
    intentTopicCollectionTree {
      data {
        id
        displayName
        parentId
      }
      count
    }
  }
`;

/**
 * __useGetIntentTopicCollectionTreeQuery__
 *
 * To run a query within a React component, call `useGetIntentTopicCollectionTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntentTopicCollectionTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntentTopicCollectionTreeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIntentTopicCollectionTreeQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetIntentTopicCollectionTreeQuery,
    GetIntentTopicCollectionTreeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetIntentTopicCollectionTreeQuery,
    GetIntentTopicCollectionTreeQueryVariables
  >(GetIntentTopicCollectionTreeDocument, options);
}
export function useGetIntentTopicCollectionTreeLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetIntentTopicCollectionTreeQuery,
    GetIntentTopicCollectionTreeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetIntentTopicCollectionTreeQuery,
    GetIntentTopicCollectionTreeQueryVariables
  >(GetIntentTopicCollectionTreeDocument, options);
}
export function useGetIntentTopicCollectionTreeSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        GetIntentTopicCollectionTreeQuery,
        GetIntentTopicCollectionTreeQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    GetIntentTopicCollectionTreeQuery,
    GetIntentTopicCollectionTreeQueryVariables
  >(GetIntentTopicCollectionTreeDocument, options);
}
export type GetIntentTopicCollectionTreeQueryHookResult = ReturnType<
  typeof useGetIntentTopicCollectionTreeQuery
>;
export type GetIntentTopicCollectionTreeLazyQueryHookResult = ReturnType<
  typeof useGetIntentTopicCollectionTreeLazyQuery
>;
export type GetIntentTopicCollectionTreeSuspenseQueryHookResult = ReturnType<
  typeof useGetIntentTopicCollectionTreeSuspenseQuery
>;
export type GetIntentTopicCollectionTreeQueryResult = Apollo.QueryResult<
  GetIntentTopicCollectionTreeQuery,
  GetIntentTopicCollectionTreeQueryVariables
>;
export const GetIntentBuyersJourneyDocument = gql`
  query GetIntentBuyersJourney {
    intentBuyersJourney {
      data {
        id
        name
        description
      }
      count
    }
  }
`;

/**
 * __useGetIntentBuyersJourneyQuery__
 *
 * To run a query within a React component, call `useGetIntentBuyersJourneyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntentBuyersJourneyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntentBuyersJourneyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIntentBuyersJourneyQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetIntentBuyersJourneyQuery,
    GetIntentBuyersJourneyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetIntentBuyersJourneyQuery,
    GetIntentBuyersJourneyQueryVariables
  >(GetIntentBuyersJourneyDocument, options);
}
export function useGetIntentBuyersJourneyLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetIntentBuyersJourneyQuery,
    GetIntentBuyersJourneyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetIntentBuyersJourneyQuery,
    GetIntentBuyersJourneyQueryVariables
  >(GetIntentBuyersJourneyDocument, options);
}
export function useGetIntentBuyersJourneySuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        GetIntentBuyersJourneyQuery,
        GetIntentBuyersJourneyQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    GetIntentBuyersJourneyQuery,
    GetIntentBuyersJourneyQueryVariables
  >(GetIntentBuyersJourneyDocument, options);
}
export type GetIntentBuyersJourneyQueryHookResult = ReturnType<
  typeof useGetIntentBuyersJourneyQuery
>;
export type GetIntentBuyersJourneyLazyQueryHookResult = ReturnType<
  typeof useGetIntentBuyersJourneyLazyQuery
>;
export type GetIntentBuyersJourneySuspenseQueryHookResult = ReturnType<
  typeof useGetIntentBuyersJourneySuspenseQuery
>;
export type GetIntentBuyersJourneyQueryResult = Apollo.QueryResult<
  GetIntentBuyersJourneyQuery,
  GetIntentBuyersJourneyQueryVariables
>;
export const GetIntentContextTypesDocument = gql`
  query GetIntentContextTypes {
    intentContextType {
      data {
        id
        name
        description
      }
      count
    }
  }
`;

/**
 * __useGetIntentContextTypesQuery__
 *
 * To run a query within a React component, call `useGetIntentContextTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntentContextTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntentContextTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIntentContextTypesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetIntentContextTypesQuery,
    GetIntentContextTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetIntentContextTypesQuery,
    GetIntentContextTypesQueryVariables
  >(GetIntentContextTypesDocument, options);
}
export function useGetIntentContextTypesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetIntentContextTypesQuery,
    GetIntentContextTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetIntentContextTypesQuery,
    GetIntentContextTypesQueryVariables
  >(GetIntentContextTypesDocument, options);
}
export function useGetIntentContextTypesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        GetIntentContextTypesQuery,
        GetIntentContextTypesQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    GetIntentContextTypesQuery,
    GetIntentContextTypesQueryVariables
  >(GetIntentContextTypesDocument, options);
}
export type GetIntentContextTypesQueryHookResult = ReturnType<
  typeof useGetIntentContextTypesQuery
>;
export type GetIntentContextTypesLazyQueryHookResult = ReturnType<
  typeof useGetIntentContextTypesLazyQuery
>;
export type GetIntentContextTypesSuspenseQueryHookResult = ReturnType<
  typeof useGetIntentContextTypesSuspenseQuery
>;
export type GetIntentContextTypesQueryResult = Apollo.QueryResult<
  GetIntentContextTypesQuery,
  GetIntentContextTypesQueryVariables
>;
export const GetSuggestedTopicsDocument = gql`
  query GetSuggestedTopics($ids: [Identifier!]!) {
    suggestedTopic(ids: $ids) {
      data {
        matchingTopic {
          id
          displayName
        }
        hasMatching {
          taxonomy
        }
        score
      }
      count
    }
  }
`;

/**
 * __useGetSuggestedTopicsQuery__
 *
 * To run a query within a React component, call `useGetSuggestedTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedTopicsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetSuggestedTopicsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetSuggestedTopicsQuery,
    GetSuggestedTopicsQueryVariables
  > &
    (
      | { variables: GetSuggestedTopicsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetSuggestedTopicsQuery,
    GetSuggestedTopicsQueryVariables
  >(GetSuggestedTopicsDocument, options);
}
export function useGetSuggestedTopicsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetSuggestedTopicsQuery,
    GetSuggestedTopicsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetSuggestedTopicsQuery,
    GetSuggestedTopicsQueryVariables
  >(GetSuggestedTopicsDocument, options);
}
export function useGetSuggestedTopicsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        GetSuggestedTopicsQuery,
        GetSuggestedTopicsQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    GetSuggestedTopicsQuery,
    GetSuggestedTopicsQueryVariables
  >(GetSuggestedTopicsDocument, options);
}
export type GetSuggestedTopicsQueryHookResult = ReturnType<
  typeof useGetSuggestedTopicsQuery
>;
export type GetSuggestedTopicsLazyQueryHookResult = ReturnType<
  typeof useGetSuggestedTopicsLazyQuery
>;
export type GetSuggestedTopicsSuspenseQueryHookResult = ReturnType<
  typeof useGetSuggestedTopicsSuspenseQuery
>;
export type GetSuggestedTopicsQueryResult = Apollo.QueryResult<
  GetSuggestedTopicsQuery,
  GetSuggestedTopicsQueryVariables
>;
export const GetIntentTopicsDocument = gql`
  query GetIntentTopics(
    $ids: [Identifier]
    $displayNames: [String]
    $displayName: String
    $ignoreProvisioning: Boolean
    $userEmail: String
  ) {
    intentTopic(
      ids: $ids
      displayNames: $displayNames
      displayName: $displayName
      ignoreProvisioning: $ignoreProvisioning
      userEmail: $userEmail
    ) {
      data {
        id
        topicName
        displayName
        category
        collectionTree
      }
      count
    }
  }
`;

/**
 * __useGetIntentTopicsQuery__
 *
 * To run a query within a React component, call `useGetIntentTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntentTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntentTopicsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      displayNames: // value for 'displayNames'
 *      displayName: // value for 'displayName'
 *      ignoreProvisioning: // value for 'ignoreProvisioning'
 *      userEmail: // value for 'userEmail'
 *   },
 * });
 */
export function useGetIntentTopicsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetIntentTopicsQuery,
    GetIntentTopicsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetIntentTopicsQuery,
    GetIntentTopicsQueryVariables
  >(GetIntentTopicsDocument, options);
}
export function useGetIntentTopicsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetIntentTopicsQuery,
    GetIntentTopicsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetIntentTopicsQuery,
    GetIntentTopicsQueryVariables
  >(GetIntentTopicsDocument, options);
}
export function useGetIntentTopicsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        GetIntentTopicsQuery,
        GetIntentTopicsQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    GetIntentTopicsQuery,
    GetIntentTopicsQueryVariables
  >(GetIntentTopicsDocument, options);
}
export type GetIntentTopicsQueryHookResult = ReturnType<
  typeof useGetIntentTopicsQuery
>;
export type GetIntentTopicsLazyQueryHookResult = ReturnType<
  typeof useGetIntentTopicsLazyQuery
>;
export type GetIntentTopicsSuspenseQueryHookResult = ReturnType<
  typeof useGetIntentTopicsSuspenseQuery
>;
export type GetIntentTopicsQueryResult = Apollo.QueryResult<
  GetIntentTopicsQuery,
  GetIntentTopicsQueryVariables
>;
export const GetIntentTopicsByIdsDocument = gql`
  query GetIntentTopicsByIds($ids: [Identifier!]!) {
    intentTopic(ids: $ids, ignoreProvisioning: true) {
      data {
        id
        topicName
        displayName
        category
        collectionTree
      }
      count
    }
  }
`;

/**
 * __useGetIntentTopicsByIdsQuery__
 *
 * To run a query within a React component, call `useGetIntentTopicsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntentTopicsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntentTopicsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetIntentTopicsByIdsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetIntentTopicsByIdsQuery,
    GetIntentTopicsByIdsQueryVariables
  > &
    (
      | { variables: GetIntentTopicsByIdsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetIntentTopicsByIdsQuery,
    GetIntentTopicsByIdsQueryVariables
  >(GetIntentTopicsByIdsDocument, options);
}
export function useGetIntentTopicsByIdsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetIntentTopicsByIdsQuery,
    GetIntentTopicsByIdsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetIntentTopicsByIdsQuery,
    GetIntentTopicsByIdsQueryVariables
  >(GetIntentTopicsByIdsDocument, options);
}
export function useGetIntentTopicsByIdsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        GetIntentTopicsByIdsQuery,
        GetIntentTopicsByIdsQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    GetIntentTopicsByIdsQuery,
    GetIntentTopicsByIdsQueryVariables
  >(GetIntentTopicsByIdsDocument, options);
}
export type GetIntentTopicsByIdsQueryHookResult = ReturnType<
  typeof useGetIntentTopicsByIdsQuery
>;
export type GetIntentTopicsByIdsLazyQueryHookResult = ReturnType<
  typeof useGetIntentTopicsByIdsLazyQuery
>;
export type GetIntentTopicsByIdsSuspenseQueryHookResult = ReturnType<
  typeof useGetIntentTopicsByIdsSuspenseQuery
>;
export type GetIntentTopicsByIdsQueryResult = Apollo.QueryResult<
  GetIntentTopicsByIdsQuery,
  GetIntentTopicsByIdsQueryVariables
>;
export const SearchIntentTopicsDocument = gql`
  query SearchIntentTopics($displayName: String!) {
    intentTopic(displayName: $displayName, ignoreProvisioning: true) {
      data {
        id
        topicName
        displayName
        category
        collectionTree
      }
      count
    }
  }
`;

/**
 * __useSearchIntentTopicsQuery__
 *
 * To run a query within a React component, call `useSearchIntentTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchIntentTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchIntentTopicsQuery({
 *   variables: {
 *      displayName: // value for 'displayName'
 *   },
 * });
 */
export function useSearchIntentTopicsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SearchIntentTopicsQuery,
    SearchIntentTopicsQueryVariables
  > &
    (
      | { variables: SearchIntentTopicsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    SearchIntentTopicsQuery,
    SearchIntentTopicsQueryVariables
  >(SearchIntentTopicsDocument, options);
}
export function useSearchIntentTopicsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SearchIntentTopicsQuery,
    SearchIntentTopicsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    SearchIntentTopicsQuery,
    SearchIntentTopicsQueryVariables
  >(SearchIntentTopicsDocument, options);
}
export function useSearchIntentTopicsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        SearchIntentTopicsQuery,
        SearchIntentTopicsQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    SearchIntentTopicsQuery,
    SearchIntentTopicsQueryVariables
  >(SearchIntentTopicsDocument, options);
}
export type SearchIntentTopicsQueryHookResult = ReturnType<
  typeof useSearchIntentTopicsQuery
>;
export type SearchIntentTopicsLazyQueryHookResult = ReturnType<
  typeof useSearchIntentTopicsLazyQuery
>;
export type SearchIntentTopicsSuspenseQueryHookResult = ReturnType<
  typeof useSearchIntentTopicsSuspenseQuery
>;
export type SearchIntentTopicsQueryResult = Apollo.QueryResult<
  SearchIntentTopicsQuery,
  SearchIntentTopicsQueryVariables
>;
